import { CATALOG_SLICE_CACHE_TIME, CatalogSlice } from '@/redux/modules/catalog/catalog.types';
import { createSelector } from 'reselect';
import { emptyCatalog } from '@/types/Catalog';
import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState): CatalogSlice => state.catalog;
const idSelector = (_: GlobalState, id: number) => id;

const byIdSelector = createSelector(stateSelector, (state) => state.byId);

const loadedSelector = createSelector(stateSelector, (state) => state.loaded);
const getLoadTimeForCatalog = createSelector([loadedSelector, idSelector], (loaded, id) => loaded[id] || 0);

const loadingSelector = createSelector(stateSelector, (state) => state.loading);
export const isCatalogLoading = createSelector([loadingSelector, idSelector], (loading, id) => loading.includes(id));

export const getCatalog = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] ?? emptyCatalog);

export const getCatalogTitle = createSelector([getCatalog], (catalog) => catalog.title);
export const getCatalogSellerId = createSelector([getCatalog], (catalog) => catalog.sellerId);
export const getCatalogEndTs = createSelector([getCatalog], (catalog) => catalog.saleEndTs);

const shouldFetchCatalog = createSelector(
    [getCatalog, getLoadTimeForCatalog, isCatalogLoading],
    (catalog, loaded, loading) => {
        if (catalog) {
            const time = Date.now();
            const diff = time - loaded;
            if (diff < CATALOG_SLICE_CACHE_TIME) {
                return false;
            }
        }
        return !loading;
    }
);

export const whichCatalogsNeeded = (state: GlobalState, catalogIds: number[]) =>
    catalogIds.filter((catalogId) => shouldFetchCatalog(state, catalogId));
